import { Component } from '@wix/thunderbolt-becky-types'
import _ from 'lodash'

export const defaultToViewItem = (rawItem: any, refs: any) => {
	const result = { ...rawItem, ...refs }
	delete result.metaData
	return result
}

const COMPONENT_TYPE_MAPPING: Record<string, string> = {
	AppPage: 'Page',
	BoxSlideShow: 'SlideShowContainer',
	BoxSlideShowSlide: 'SlideShowSlide',
	InlinePopup: 'MenuContainer',
	InlinePopupToggle: 'MenuToggle',
	MobileMerge: 'DivWithChildren',
	OldBlogDeprecation: 'Container',
	PopupCloseTextButton: 'SiteButton',
	SiteRegionContainer: 'Container',
	SlideshowItem: 'Container',
	StateBoxFormState: 'SlideShowSlide',
	StateBoxState: 'SlideShowSlide',
	StripContainerSlideShow: 'SlideShowContainer',
	StripContainerSlideShowSlide: 'SlideShowSlide',
	TwitterFeed: 'DivWithChildren',
	WGooglePlusOne: 'DivWithChildren',
}

const mapComponentType = (componentType: string): string => COMPONENT_TYPE_MAPPING[componentType] || componentType

export const fixStructure = (component: Component): Component => {
	const { componentType, skin } = component
	const fixedComponent = { ...component, componentType: mapComponentType(_.last(componentType.split('.'))!) }
	if (skin) {
		fixedComponent.skin = skin.startsWith('svgshape.') ? skin : _.last(skin.split('.'))!
	}
	return fixedComponent
}
